import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

const empty = { name: "", email: "", phone: "", subject: "", message: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      setForm(empty);
      toast.success("Message sent. We'll be in touch soon.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="grid gap-4 sm:grid-cols-2">
      <input required minLength={2} className="field" placeholder="Name" value={form.name} onChange={set("name")} data-testid="contact-name-input" aria-label="Name" />
      <input required type="email" className="field" placeholder="Email" value={form.email} onChange={set("email")} data-testid="contact-email-input" aria-label="Email" />
      <input type="tel" className="field" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} data-testid="contact-phone-input" aria-label="Phone" />
      <input className="field" placeholder="Subject" value={form.subject} onChange={set("subject")} data-testid="contact-subject-input" aria-label="Subject" />
      <textarea required minLength={2} rows={5} className="field resize-none sm:col-span-2" placeholder="How can we help?" value={form.message} onChange={set("message")} data-testid="contact-message-input" aria-label="Message" />
      <div className="flex items-center justify-between gap-4 sm:col-span-2">
        {sent ? <p data-testid="contact-success" className="text-sm text-[#F3E5AB]">Thank you — your message is on its way.</p> : <span />}
        <button type="submit" disabled={loading} data-testid="contact-submit-button"
          className="inline-flex h-12 items-center gap-2 rounded-full bg-[#D4AF37] px-7 text-sm font-medium text-[#07040D] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#F3E5AB] disabled:opacity-60">
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Send Message
        </button>
      </div>
    </form>
  );
};
